import { computed, Injectable, Signal } from "@angular/core";
import { Observable } from "rxjs";
import { DsrBrandBase } from "src/app/api/models/dsr/dsr-multi-brand.interface";
import { DsrMultiBrandStore } from "./dsr-multi-brand.store";

@Injectable({
    providedIn: 'root'
})
export class DsrMultiBrandQuery {

    constructor(
        private store: DsrMultiBrandStore,
    ) { }

    setLoading(loading: boolean): void {
        this.store.set({ loading });
    }

    getLoading(): Signal<boolean | undefined> {
        return this.store.signal('loading');
    }

    selectLoading(): Observable<boolean | undefined> {
        return this.store.select('loading');
    }

    setBrands(brands: DsrBrandBase[]): void {
        //make sure default brand is first
        const sortedBrands = [...brands].sort((a, b) => (b.isDefault ? 1 : 0) - (a.isDefault ? 1 : 0));
        this.store.set({ brands: sortedBrands });
    }

    getBrands(): Signal<DsrBrandBase[]> {
        return this.store.signal('brands');
    }

    selectBrands(): Observable<DsrBrandBase[]> {
        return this.store.select('brands');
    }

    getBrandById(id: string): Signal<DsrBrandBase | undefined> {
        return computed(() => this.store.get('brands').find(b => b.id === id));
    }

    updateBrandLogoUrl(brandId: string, url: string): void {
        const brands = this.store.get('brands');
        const updated = brands.map(b => b.id === brandId ? { ...b, brandLogoUrl: url } : b);
        this.store.set({ brands: updated });
    }

    hasBrand(id: string): Signal<boolean> {
        return computed(() => this.store.get('brands').some(b => b.id === id));
    }

}
